import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const SearchBar = ({ value, onChange }: SearchBarProps) => {
  return (
    <TextField
      variant="standard"
      placeholder="Search Customers"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        '& .MuiInput-underline:before': {
          borderBottomColor: 'lightgray',
        },
        '& .MuiInput-underline:hover:before': {
          borderBottomColor: 'gray',
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'lightgray',
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: '#003366' }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
